import httpClient from "./httpClient";

export interface CreateDeductionDto {
  partnerId: number;
  name: string;
  description?: string;
  amount: number;
  frequency: string;
  startDate?: string;
  endDate?: string;
  applicationDate?: string;
  hasExpiration?: boolean;
  status?: string;
  isTaxable?: boolean;
}

export interface FindDeductionDto {
  partnerId?: number;
  start: string;
  end: string;
  consultedDate?: string;
}

export interface UpdateDeductionDto {
  name?: string;
  description?: string;
  amount?: number;
  frequency?: string;
  startDate?: string;
  endDate?: string;
  applicationDate?: string;
  hasExpiration?: boolean;
  status?: string;
  isTaxable?: boolean;
}

export interface Deduction {
  id: string;
  name: string;
  description?: string;
  amount: number;
  frequency: string;
  startDate?: string;
  endDate?: string;
  applicationDate?: string;
  hasExpiration: boolean;
  status: string;
  isTaxable: boolean;
  createdAt: string;
  updatedAt: string;
  partner: {
    id: number;
    person: {
      firstName: string;
      lastName: string;
      secondLastName?: string;
    };
  };
  authorizedBy: {
    id: number;
    name: string;
    lastName: string;
    secondLastName?: string;
  };
}

export const saveDeduction = async (
  data: CreateDeductionDto
): Promise<Deduction> => {
  const response = await httpClient.post("/deductions", data);
  return response.data;
};

export const findActiveDeductions = async (
  data: FindDeductionDto
): Promise<Deduction[]> => {
  const response = await httpClient.get("/deductions", { params: data });
  return response.data;
};

export const findDeductionsByPartner = async (
  partnerId: number
): Promise<Deduction[]> => {
  const response = await httpClient.get(`/deductions/partner/${partnerId}`);
  return response.data;
};

export const findDeduction = async (id: string): Promise<Deduction> => {
  const response = await httpClient.get(`/deductions/details/${id}`);
  return response.data;
};

export const updateDeduction = async (
  id: string,
  data: UpdateDeductionDto
): Promise<Deduction> => {
  const response = await httpClient.put(`/deductions/${id}`, data);
  return response.data;
};

export const deleteDeduction = async (id: string): Promise<void> => {
  await httpClient.delete(`/deductions/${id}`);
};

// Plantillas de deducciones
export interface DeductionTemplate {
  id: string;
  name: string;
  description: string;
  amount: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDeductionTemplateDto {
  name: string;
  description: string;
  amount: number;
}

export interface UpdateDeductionTemplateDto {
  name?: string;
  description?: string;
  amount?: number;
}

export const saveDeductionTemplate = async (
  data: CreateDeductionTemplateDto
): Promise<DeductionTemplate> => {
  const response = await httpClient.post("/deductions/templates", data);
  return response.data;
};

export const findDeductionTemplates = async (
  searchQuery?: string, 
  limit?: number
): Promise<DeductionTemplate[]> => {
  const params: any = {};
  
  if (searchQuery && searchQuery.trim().length > 0) {
    params.search = searchQuery.trim();
  }
  
  if (limit && limit > 0) {
    params.limit = limit;
  }
  
  const response = await httpClient.get("/deductions/templates", { params });
  return response.data;
};

export const findDeductionTemplate = async (id: string): Promise<DeductionTemplate> => {
  const response = await httpClient.get(`/deductions/templates/${id}`);
  return response.data;
};

export const updateDeductionTemplate = async (
  id: string,
  data: UpdateDeductionTemplateDto
): Promise<DeductionTemplate> => {
  const response = await httpClient.put(`/deductions/templates/${id}`, data);
  return response.data;
};

export const deleteDeductionTemplate = async (
  id: string
): Promise<void> => {
  await httpClient.delete(`/deductions/templates/${id}`);
};
